<template>
  <div>
    <topMenu Sel="5"></topMenu>
    <div>
    	<img src="../../../static/image/img5.png" style="width: 100%;"/>
    </div>

    <div class="titlebox">
    	<p class="title">PESIDENT FLOW</p>
    	<div>
    		<div class="titleleft"></div>
    		<div class="titlemiddle">入驻流程</div>
    		<div class="titleright"></div>
    	</div>
    </div>


    <div class="box">
    	<div>
    		<div style="width:120px;height:120px;background: #f2ea61;border-radius: 50%;">1</div>
    		<p>提交申请</p>
    	</div>
    	<div>
    		<div style="width:120px;height:120px;background: #f2ea61;border-radius: 50%;">2</div>
    		<p>审核签约</p>
    	</div>
    	<div>
    		<div style="width:120px;height:120px;background: #f2ea61;border-radius: 50%;">3</div>
    		<p>录入产品</p>
    	</div>
    	<div>
    		<div style="width:120px;height:120px;background: #f2ea61;border-radius: 50%;">4</div>
    		<p>门店上线</p>
    	</div>
    </div>

    <div class="rzsq">入驻申请</div>
    <p class="p1">平台规则</p>


    <div class="titlebox" style="margin-top: 30px;">
    	<p class="title">BRAND IN</p>
    	<div>
    		<div class="titleleft"></div>
    		<div class="titlemiddle">入驻品牌</div>
    		<div class="titleright"></div>
    	</div>
    </div>

    <div class="zpcon">
    	<div>
    		<div style="width:150px;height: 80px;background: #333;border-radius: 10px;"></div>
    	</div>
    	<div>
    		<div style="width: 150px;height: 80px;background: #333;border-radius: 10px;"></div>
    	</div>
    	<div>
    		<div style="width: 150px;height: 80px;background: #333;border-radius: 10px;"></div>
    	</div>
    	<div>
    		<div style="width: 150px;height: 80px;background: #333;border-radius: 10px;"></div>
    	</div>
    	<div>
    		<div style="width: 150px;height: 80px;background: #333;border-radius: 10px;"></div>
    	</div>
    </div>
    <div class="lianxi">
    	<p>联系方式</p>
    	<div>
    		<span>客服电话:000-01040101</span>
    		<span>微博:1033153688</span>
    		<span>微信:1033153688</span>
    		<span>快手:000-01040101</span>
    		<span>抖音:1033153688</span>
    		<span>邮箱:1033153688</span>
    		<span>QQ:000-01040101</span>
    	</div>
    </div>
    <div style="width: 100%;background: #434343;height: 100px;display: flex;align-items: center;justify-content: center;">
    	<img src="../../../static/image/img2.png" style="height:60px;"/>
    	<img src="../../../static/image/logo1.png" style="height:60px;"/>
    </div>
    <div class="footer">
    	<div style="padding-top: 20px;box-sizing: border-box;padding-left: 20px;">
    		<span>营业执照</span>
    		<span>加入我们</span>
    		<span>在线客服</span>
    	</div>
    	<p>版权所有：辽宁卡丁生活科技有限公司</p>
    	<p>辽ICP备20007334号</p>
    </div>
  </div>
</template>

<script>
  import topMenu from './components/topMenu.vue'
  export default {
    components:{
      topMenu
    },
    data() {
      return {

      }
    },
    //初始化
    created(){

    },
    methods:{

    }
  }
</script>

<style scoped>
  /* 设置滚动条的样式 */
  ::-webkit-scrollbar {
  	width: 2px;
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
  	border-radius: 10px;
  	background: #d2d2d2;
  }
  .logo1 {
  	height:40px;
  }
  .titlebox {
  	width: 100%;
  	height:80px;
  	box-sizing: border-box;
  	position: relative;
  }
  .titlebox p {
  	color: #999;
  	font-size:30px;
  	text-align: center;
  	line-height:40px;
  	font-family: "黑体";
  }
  .titlebox>div {
  	width: 220px;
  	height:30px;
  	position: absolute;
  	left: 50%;
  	transform: translateX(-50%);
  	text-align: center;
  	line-height: 40px;
  	letter-spacing: 1px;
  	font-family: '黑体';
  	font-weight: bold;
  	font-size: 20px;
  	color: #666;
  	display: flex;
  	align-items: center;
  	justify-content: center;
  }
  .titlebox>div>.titleleft {
  	width: calc(50% - 50px);
  	height: 1px;
  	position: absolute;
  	left: 0;
  	top: 50%;
  	background:#f2ea61;
  }
  .titlebox>div>.titleright {
  	width: calc(50% - 50px);
  	height: 1px;
  	position: absolute;
  	right: 0;
  	top: 50%;
  	background:#f2ea61;
  }

  .box {
  	width:800px;
  	height:150px;
  	margin: 10px auto;
  	display: flex;
  	align-items: center;
  	justify-content: space-between;
  	box-sizing: border-box;
  }
  .box > div>div {
  	line-height: 120px;
  	font-size: 30px;
  	color: #fff;
  	text-align: center;
  }
  .box > div > p {
  	color: #111;
  	text-align: center;
  	line-height:40px;
  	font-family: '黑体';
  }

  .footer {
  	width: 100%;
  	height: 100px;
  	box-sizing: border-box;
  }
  .footer div span {
  	margin-left: 20px;
  	font-size: 14px;
  	line-height: 20px;
  	color: #999;
  }
  .footer p {
  	text-align: center;
  	font-size: 15px;
  	line-height: 20px;
  	color: #666;
  	margin-bottom:5px;
  }

  .rzsq {
  	width:250px;
  	margin: 20px auto 0px;
  	background:#f2ea61;
  	color: #fff;
  	font-size: 20px;
  	height:50px;
  	line-height: 50px;
  	text-align: center;
  	border-radius:25px;
  	letter-spacing: 1px;
  	font-family: '黑体';
  }
  .p1 {
  	text-align: center;
  	font-size: 15px;
  	font-family: "微软雅黑";
  	line-height: 20px;
  	margin-top: 10px;
  }
  .zpcon{
  	width:900px;
  	height:150px;
  	margin: 20px auto;
  	display: flex;
  	align-items: center;
  	justify-content: space-between;
  	box-sizing: border-box;
  }

  .lianxi {
  	 width:100%;
  	 height:120px;
  	 background: #ccc;
  }
  .lianxi p {
  	text-align: center;
  	color: #111;
  	font-family: '黑体';
  	font-size:22px;
  	line-height:40px;
  }
  .lianxi>div {
  	display: flex;
  	align-items: center;
  	justify-content: space-around;
  	flex-wrap: wrap;
  }
  .lianxi>div>span {
  	width: 22%;
  	display: inline-block;
  	font-family: "微软雅黑";
  	line-height: 35px;
  	text-align: center;
  	color: #666;
  	padding-left: 10px;
  	box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/official/sjrz.vue